import { PartialRootState, ProjectTemplate } from './types';

export const getProjectTemplatesList = ({
  projectTemplates,
}: PartialRootState): ProjectTemplate[] => projectTemplates.list;

export const getProjectTemplatesIsLoading = ({
  projectTemplates,
}: PartialRootState): boolean => projectTemplates.isLoading;
